module.exports = __webpack_public_path__ + "static/the-bell-3606756c84e556e54ab09635c874d7c6.png";